import React, { useState } from "react";
import axios from "axios";
import "./App.css";

function App() {
  const [data, setData] = useState({});
  const [location, setLocation] = useState("");
  const [error, setError] = useState(null);

  //const apiKey = process.env.REACT_APP_API_KEY; //Reference the API key
 const url = `https://api.openweathermap.org/data/2.5/weather?q=${location}&units=imperial&appid=fe9d5f6f0f3c4b2ac5d8c9f3bd88a60f`;
  
   const searchLocation = (event) => {
    if (event.key === 'Enter') {
      axios.get(url).then((response) => {
        setData(response.data);
        console.log(response.data);
        setError(null);
      })
      .catch((error) => {
        setError("Please enter the correct location name!");
        console.error("error fetching data", error);
      })
      .finally(() => {
        setLocation('');
      });
     }
  }

  return (
    <div className="app">
      <div className="search">
        <input
          value={location}
          onChange={event => setLocation(event.target.value)}
          onKeyPress={searchLocation}
          placeholder='Enter Location'
          type="text" />
      </div>
      <div className="container">
        <div className="top">
          <div className="location">
          {error ? <p className="error">{error}</p> : <p>{data.name}</p>}
          </div>
          <div className="temp">
            {data.main ? <h1>{((data.main.temp - 32) * 5/9).toFixed()}°C</h1> : null}
          </div>
          <div className="description">
            {data.weather ? <p>{data.weather[0].main}</p> : null}
          </div>
        </div>

           {data.name !== undefined &&
          <div className="bottom">
            <div className="feels">
              {data.main ? <p className='bold'>{((data.main.feels_like - 32)*5/9).toFixed()}°C</p> : null}
              <p>Feels Like</p>
            </div>
            <div className="humidity">
              {data.main ? <p className='bold'>{data.main.humidity}%</p> : null}
              <p>Humidity</p>
            </div>
            <div className="wind">
              {data.wind ? <p className='bold'>{data.wind.speed.toFixed()} MPH</p> : null}
              <p>Wind Speed</p>
            </div>
          </div>
        }

      </div>
    </div>
  );
}

export default App;